import PropTypes from 'prop-types';
import React from 'react';
import Select from './index';

export default function renderSelect({ input, meta: { touched, error, warning }, ...args }) {
  const validationMessage = touched
    ? error || warning || args.validationMessage
    : args.validationMessage;
  const isValid = !(error || warning);
  const id = args.id || input.name || null;
  // redux-form returns instance of Map for object from initial values
  const value = input.value && input.value.toJS ? input.value.toJS() : input.value;

  return (
    <Select
      validationMessage={validationMessage}
      isValid={isValid}
      id={id}
      {...args}
      {...input}
      value={value}
    />
  );
}

renderSelect.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string,
  }),
};

renderSelect.optionRenderer = (option) => `${option.value} — ${option.label}`;
